import * as Yup from 'yup';
import { CourtFile, Loan, User } from '@models';

export function useValidationSchema() {
  return Yup.object<Loan>().shape({
    loanedFile: Yup.mixed<CourtFile>().nullable().required(),
    borrower: Yup.mixed<User>().nullable().required(),
    relatedFile: Yup.mixed<CourtFile>().nullable(),
  });
}
